export default __webpack_public_path__ + "static/media/group.e4bfed41.png";